var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AreaAccordion", {
    attrs: { options: _vm.options, value: _vm.value },
    on: {
      added: function ($event) {
        return _vm.add($event)
      },
      updated: function ($event) {
        return _vm.update($event)
      },
      removed: function ($event) {
        return _vm.remove($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }